import lazarette from './lazarette'

// Constants
import { DEV_MODE_TOKEN } from '../constants/system'
import {
  JWT_TOKEN_KEY,
  // TODO: - Uncomment when deprecated JWT_TOKEN_KEY
  ACCESS_TOKEN,
  LISTING_KEY,
  EXTENSION_DEBOUNCE_KEY_MAP,
} from './constants'

export const getClientTokenFromStorage = async () => {
  const storageValues = await lazarette.get([
    DEV_MODE_TOKEN,
    JWT_TOKEN_KEY,
    ACCESS_TOKEN,
  ])

  if (storageValues[DEV_MODE_TOKEN]) {
    return storageValues[DEV_MODE_TOKEN]
  } else {
    // TODO: - uncomment when deprecating JWT_TOKEN_KEY
    // return storageValues[ACCESS_TOKEN] ?? null

    // TODO: - remove when deprecating JWT_TOKEN_KEY

    return storageValues[JWT_TOKEN_KEY] ?? null
  }
}

export const getListingsFromStorage = async () => {
  const storageValues = await lazarette.get(LISTING_KEY)

  return storageValues[LISTING_KEY] ?? []
}

export const getExtensionDebounceKeys = async () => {
  const storageValues = await lazarette.get(EXTENSION_DEBOUNCE_KEY_MAP)

  return storageValues[EXTENSION_DEBOUNCE_KEY_MAP] ?? {}
}
